var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.showCompany ? _c('company-selection', {
    attrs: {
      "filter": _vm.CompanyServiceEnum.RENTAL
    },
    model: {
      value: _vm.company,
      callback: function callback($$v) {
        _vm.company = $$v;
      },
      expression: "company"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.title'),
      "outlined": ""
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.required,
      "label": _vm.$t('objects.rental.period.start') + ' *',
      "outlined": "",
      "type": "datetime-local",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.value.start,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "start", $$v);
      },
      expression: "value.start"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.required,
      "label": _vm.$t('objects.rental.period.end') + ' *',
      "outlined": "",
      "type": "datetime-local",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.value.end,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "end", $$v);
      },
      expression: "value.end"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.isDelivery')
    },
    model: {
      value: _vm.value.isDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDelivery", $$v);
      },
      expression: "value.isDelivery"
    }
  }), _vm.value.isDelivery ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "datetime-local",
      "label": _vm.$t('objects.rental.deliveryDate') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.deliveryDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "deliveryDateFormable", $$v);
      },
      expression: "value.deliveryDateFormable"
    }
  })], 1), _vm.value.deliveryLocation ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.street') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.deliveryLocation.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "street", $$v);
      },
      expression: "value.deliveryLocation.street"
    }
  })], 1) : _vm._e(), _vm.value.deliveryLocation ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.zip') + ' *',
      "outlined": "",
      "rules": _vm.germanZipRule,
      "dense": ""
    },
    model: {
      value: _vm.value.deliveryLocation.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "zip", $$v);
      },
      expression: "value.deliveryLocation.zip"
    }
  })], 1) : _vm._e(), _vm.value.deliveryLocation ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.city') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.deliveryLocation.city,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "city", $$v);
      },
      expression: "value.deliveryLocation.city"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.isPickup')
    },
    model: {
      value: _vm.value.isPickup,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isPickup", $$v);
      },
      expression: "value.isPickup"
    }
  }), _vm.value.isPickup ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "datetime-local",
      "label": _vm.$t('objects.rental.pickupDate') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.pickupDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pickupDateFormable", $$v);
      },
      expression: "value.pickupDateFormable"
    }
  })], 1), _vm.value.pickupLocation ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.street') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.pickupLocation.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "street", $$v);
      },
      expression: "value.pickupLocation.street"
    }
  })], 1) : _vm._e(), _vm.value.pickupLocation ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.zip') + ' *',
      "outlined": "",
      "rules": _vm.germanZipRule,
      "dense": ""
    },
    model: {
      value: _vm.value.pickupLocation.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "zip", $$v);
      },
      expression: "value.pickupLocation.zip"
    }
  })], 1) : _vm._e(), _vm.value.pickupLocation ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.city') + ' *',
      "outlined": "",
      "rules": _vm.required,
      "dense": ""
    },
    model: {
      value: _vm.value.pickupLocation.city,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "city", $$v);
      },
      expression: "value.pickupLocation.city"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.vehicleGroup'),
      "outlined": ""
    },
    model: {
      value: _vm.value.vehicleGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "vehicleGroup", $$v);
      },
      expression: "value.vehicleGroup"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.rate'),
      "outlined": ""
    },
    model: {
      value: _vm.value.rate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "rate", $$v);
      },
      expression: "value.rate"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('objects.rental.vehicleModel'),
      "outlined": ""
    },
    model: {
      value: _vm.value.vehicleModel,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "vehicleModel", $$v);
      },
      expression: "value.vehicleModel"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('common.nouns.licenseplate'),
      "outlined": ""
    },
    model: {
      value: _vm.value.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "numberplate", $$v);
      },
      expression: "value.numberplate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "dense": ""
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "label": _vm.$t('objects.rental.dailyRate'),
      "outlined": ""
    },
    model: {
      value: _vm.value.dailyRate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dailyRate", _vm._n($$v));
      },
      expression: "value.dailyRate"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "label": _vm.$t('objects.rental.costCoveredByCustomer'),
      "outlined": ""
    },
    model: {
      value: _vm.value.costCoveredByCustomer,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "costCoveredByCustomer", _vm._n($$v));
      },
      expression: "value.costCoveredByCustomer"
    }
  }), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "label": _vm.$t('objects.rental.costCoveredByInsurance'),
      "outlined": ""
    },
    model: {
      value: _vm.value.costCoveredByInsurance,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "costCoveredByInsurance", _vm._n($$v));
      },
      expression: "value.costCoveredByInsurance"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('components.fleet.FleetVehicleDetailVehicleCard.notes'),
      "outlined": ""
    },
    model: {
      value: _vm.value.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "notes", $$v);
      },
      expression: "value.notes"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._t("fileUpload")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }